module.exports = __webpack_public_path__ + "img/shield_fail.540083db.svg";